
  <div class="modal-content modal-content-width">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
        <div class="row">
          <div class="col-md-8">
            Episode Search
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        

        

      </div>
     
      <div class="modal-body padding-top-0px counselling-modal">

      
            <div class="row margin-top-10 margin-bottom-10px margin-left-10px">
              <div class="col-md-5">
                <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">
                <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
              </div>
              
            
              
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
                    <div class="table-component">
                      <div class="table-responsive overflow-x">


                        <table class="table table-striped margin-left-zero "
                               cols="auto,2*,*,*,*,*,*,*">

                          <thead class="">
                            <tr>
                              <th></th>
                              <th class="">
                                PID
                              </th>
                              <th class="text-align-center">
                                Episode
                              </th>
                              <th class="">
                                Name
                              </th>
                              <!--<th class="">
                                Cycle Code
                              </th>-->
                              <th class="">
                                Reg Date
                              </th>
                              <th class="">
                                Contact
                              </th>
                              <th class="">
                                Sex
                              </th>
                              <th class="">Age</th>
                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let l of CurrentTreatmentCyclesByActorCodeController">
                              <td class="padding-top-0px padding-bottom-0px">                                
                                <button type="button" class="btn font-size-13px actions-btn-prime"
                                        (click)="activeModal.close(l)">
                                        <!--(click)="passback(l)">-->
                                  Select
                                </button>
                              </td>
                              <td class="td-padding padding-top-0px padding-bottom-0px">
                                <a (click)="ViewPatientDetails(l)" class="nav-link-hand">{{l.EggFormattedCode}}</a>
                              </td>
                              <td class="td-padding text-align-center padding-top-0px padding-bottom-0px">
                                {{l.Episode}}
                              </td>
                              <td class=" td-padding padding-top-0px padding-bottom-0px">{{l.EggName}}</td>
                              <!--<td class=" td-padding padding-top-0px padding-bottom-0px">{{l.Code}}</td>-->
                              <td class="padding-right-0px padding-left-0px padding-top-0px padding-bottom-0px">{{l.EggRegistrationDate| date:'MMM-dd-yyyy'}}</td>
                              <td class="padding-top-0px padding-bottom-0px">{{l.EggTelephone1}}</td>
                              <td class="padding-top-0px padding-bottom-0px">{{l.EggGender}}</td>
                              <td class="padding-right-0px padding-left-0px padding-top-0px padding-bottom-0px">{{l.EggAgeYears}}</td>



                            </tr>

                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>


      </div>
        <div class="modal-footer padding-top-10px padding-bottom-10px">

          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3"
                  (click)="activeModal.close('Close click')">Cancel</button>
         
        </div>
     
    </div>
  </div>
